import { render, staticRenderFns } from "./DashboardEditLog.vue?vue&type=template&id=57da7e2f&scoped=true"
import script from "./DashboardEditLog.vue?vue&type=script&lang=js"
export * from "./DashboardEditLog.vue?vue&type=script&lang=js"
import style0 from "./DashboardEditLog.vue?vue&type=style&index=0&id=57da7e2f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57da7e2f",
  null
  
)

export default component.exports